import React from 'react';

class Records extends React.Component {
    render(){
        return(
            <section className="write">
                <div className="container"><h2 className="write__title">Записи</h2><p className="write__text">В системе
                    производится запись всех разговоров по проектам с возможностью последующей выгрузки файлов с
                    применением различных фильтров. Возможно прослушивание разговоров операторов в реальном времени.</p>
                </div>
            </section>
        )
    }
}

export default Records;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/Records.js